"use strict";

function logos() {
  var sliderLogos = document.querySelector('.c-logos--mobile');
  if (!sliderLogos) return;
  var logosSwiper = new Swiper(sliderLogos, {
    slidesPerView: 1,
    spaceBetween: 10,
    autoplay: true,
    loop: true,
    breakpoints: {
      380: {
        slidesPerView: 2
      },
      560: {
        slidesPerView: 3
      }
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  });
}
logos();